import React, { lazy, Suspense } from 'react'
import { colors } from '@fs/zion-ui'
import { css } from '@linaria/core'
import { useFeatureFlag } from '@fs/zion-flags'
import { useUser } from '@fs/zion-user'
import Header2019WithData, { Header2019 } from './Header2019'
import AdminHeader, { AdminHeaderButton, AdminHeaderIconButton } from './AdminHeader'
import CFHeader from './CFHeader/CFHeader'
import LogoOnlyHeader from './LogoOnlyHeader'
import './locales'

const UnauthenticatedHeader = lazy(() => import('./UnauthenticatedHeader'))

const PlaceholderHeaderCss = css`
  height: 60px;
  background: ${colors.gray00};
`

function PlaceholderHeader() {
  return <div className={PlaceholderHeaderCss} />
}

function DefaultHeader(props) {
  const { signedIn, userLoading } = useUser()
  const showUnauthenticatedHeader = useFeatureFlag('home_header_showUnauthenticatedHeader')?.isOn
  if (userLoading) {
    return <PlaceholderHeader />
  }
  if (!showUnauthenticatedHeader || signedIn) {
    return <Header2019WithData {...props} />
  }
  return (
    <Suspense fallback={<PlaceholderHeader />}>
      <UnauthenticatedHeader {...props} />
    </Suspense>
  )
}

export default DefaultHeader
export {
  Header2019,
  AdminHeader,
  AdminHeaderIconButton,
  AdminHeaderButton,
  CFHeader,
  LogoOnlyHeader,
  UnauthenticatedHeader,
}
